"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["READY"] = "ready";
    EventTypes["LOAD_ERROR"] = "loadError";
    EventTypes["INPUT_CHANGE"] = "inputChange";
    EventTypes["CARD_TYPE"] = "cardType";
    EventTypes["RECACHE_READY"] = "recacheReady";
    EventTypes["RECACHE_LOAD_READY"] = "recacheLoadError";
    EventTypes["CVV_CHANGE"] = "cvv";
    EventTypes["REPLACE_CARD_READY"] = "replaceCardReady";
    EventTypes["REPLACE_CARD_ERROR"] = "replaceCardLoadError";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
